import axios from '@/shared/api/axios';

export interface ChangePeriodResponse {
    data: boolean;
    message: string;
    success: boolean;
    timestamp: string;
}

export const changePeriod = async (companyId: string, period: number): Promise<ChangePeriodResponse> => {
    const response = await axios.patch(`/v1/hub/companies/${companyId}/periods/${period}`);
    return response.data;
}; 